import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import AutocompleteLocation from '../AutocompleteLocation';
import FormError from '../Form/FormError';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function AutoCompleteStaticHotels(_ref) {
  var _ref$formField = _ref.formField,
    props = _ref$formField.props,
    errorStyles = _ref$formField.errorStyles,
    field = _ref.field,
    handleSetValue = _ref.handleSetValue,
    _ref$errors = _ref.errors,
    errors = _ref$errors === void 0 ? {} : _ref$errors,
    handleClearErrors = _ref.handleClearErrors;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isError = _useState4[0],
    setIsError = _useState4[1];
  useEffect(() => {
    setIsError(!!errors[field.name]);
  }, [errors[field.name]]);
  var handleClearInput = () => setInputValue('');
  var handleLocationInputChange = value => {
    setInputValue(value || '');
  };
  var getFilteredHotels = () => {
    if (!inputValue || inputValue.trim().length === 0) {
      return [];
    }
    if (!(props !== null && props !== void 0 && props.hotels)) {
      return [];
    }
    return props.hotels.filter(hotel => {
      var searchValue = inputValue.toLowerCase();
      var hotelValue = (hotel.value || hotel.label || '').toLowerCase();
      return hotelValue.includes(searchValue);
    });
  };
  if (props !== null && props !== void 0 && props.hotels && props.hotels.length > 0) {
    var filteredItems = getFilteredHotels();
    return _jsxs(_Fragment, {
      children: [_jsx(AutocompleteLocation, {
        dataTestId: "HotelsDropdownPicker",
        items: filteredItems,
        inputPlaceholder: props.placeholder,
        showElements: true,
        openListOnFocus: false,
        disableInternalFilter: true,
        autocompleteStyles: _objectSpread(_objectSpread({
          errorMarginBottom
        }, isError && {
          errorInputGroupStyles,
          errorInputElementStyles
        }), {}, {
          inputGroupStyles: wrapperStyles,
          inputElementStyles: inputStyles,
          listStyles
        }),
        onInputChange: handleLocationInputChange,
        onChange: value => {
          handleSetValue === null || handleSetValue === void 0 || handleSetValue(field.name, value);
          setInputValue(value);
          setIsError(false);
          handleClearErrors === null || handleClearErrors === void 0 || handleClearErrors(field.name);
        },
        inputSelectedValue: inputValue,
        hasClearIcon: true,
        onClearInput: handleClearInput,
        onSelectOption: props === null || props === void 0 ? void 0 : props.handleSelectOption,
        hasItemObject: true
      }), isError && _jsx(FormError, {
        errors: errors,
        name: field.name,
        extraStyles: errorStyles
      })]
    });
  }
}
var listStyles = {
  maxHeight: '16rem',
  overflow: 'scroll',
  zIndex: 10,
  mt: '10px'
};
var wrapperStyles = {
  w: '100%',
  p: 0,
  height: 'var(--chakra-space-4xl)',
  _placeholder: {
    opacity: 0.7,
    color: 'var(--chakra-darkGrey1)'
  }
};
var inputStyles = {
  border: '0.063rem solid var(--chakra-colors-lightGrey1)'
};
var errorMarginBottom = {
  mobile: 'sm',
  xs: 'md',
  sm: '0'
};
var errorInputGroupStyles = {
  borderRadius: 'var(--chakra-radii-base)',
  border: '2px solid var(--chakra-colors-error)'
};
var errorInputElementStyles = {
  border: 'none',
  borderRight: 'none',
  _hover: {
    border: 'none'
  },
  _focus: {
    border: 'none'
  },
  _active: {
    border: 'none'
  }
};